<main>
  <article>
    <ul *ngIf="loading === false; else loadingMessage">
      <li *ngFor="let file of instructionFiles">
        <a class="download-btn" [href]="file.textFileUrl" target="_blank">
          <div class="btn-title">{{file.title}}</div>
          <div class="btn-subtitle" *ngIf="file.subtitle">{{file.subtitle}}</div>
        </a>
      </li>
    </ul>

    <ng-template #loadingMessage>
      <h4>{{'LOADING_FILES' | translate}}</h4>
    </ng-template>
  </article>
</main>
